import {
  Component,
  OnInit,
  TemplateRef,
  ViewEncapsulation,
} from "@angular/core";

import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

import {
  CapacitacionView,
  CapacitacionDTO,
  CapacitacionesService,
} from "../../../../../shared/services/capacitacion.service";

import { Utils } from "../../../../../shared/utils/Utils";

declare var require: any;
const Swal = require("sweetalert2");

@Component({
  selector: "app-capacitacion-catalogo",
  templateUrl: "./capacitacion-catalogo.component.html",
  styleUrls: ["./capacitacion-catalogo.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CapacitacionCatalogoComponent implements OnInit {
  loading = false;

  searchText = "";

  stateFilter: "all" | "active" | "inactive" = "all";

  pageSize = 5;
  page = 1;

  sortColumn = "";
  sortDirection: "asc" | "desc" = "asc";

  capacitaciones: CapacitacionView[] = [];
  filteredTableItems: CapacitacionView[] = [];

  createModalRef?: NgbModalRef;
  editModalRef?: NgbModalRef;

  editCapacitacionId: number | null = null;

  createError = "";
  editError = "";

  newCapacitacionForm: CapacitacionDTO = {
    nombre: "",
    descripcion: "",
    tema: "",
    estado: 1,
  };

  editCapacitacionForm: CapacitacionDTO = {
    nombre: "",
    descripcion: "",
    tema: "",
    estado: 1,
  };

  constructor(
    private capacitacionesService: CapacitacionesService,
    private modalService: NgbModal,
  ) {}

  ngOnInit(): void {
    this.cargarCapacitaciones();
  }

  esActivo(capacitacion: CapacitacionView): boolean {
    return Number(capacitacion?.estado ?? 1) !== 0;
  }

  cargarCapacitaciones(): void {
    this.loading = true;

    this.capacitacionesService.getCapacitaciones().subscribe({
      next: (data) => {
        this.capacitaciones = data ?? [];

        this.filteredTableItems = [...this.capacitaciones];

        this.filterData();

        this.loading = false;
      },

      error: () => {
        this.loading = false;

        Swal.fire({
          icon: "error",
          title: "No se pudieron cargar las capacitaciones",
          text: "Intenta nuevamente.",
        });
      },
    });
  }

  filterData(): void {
    const term = this.searchText.trim().toLowerCase();

    const base = [...this.capacitaciones].filter((capacitacion) => {
      if (this.stateFilter === "active") {
        return this.esActivo(capacitacion);
      }

      if (this.stateFilter === "inactive") {
        return !this.esActivo(capacitacion);
      }

      return true;
    });

    this.filteredTableItems = !term
      ? base
      : base.filter((capacitacion) => {
          const nombre = capacitacion.nombre?.toLowerCase() ?? "";

          const tema = capacitacion.tema?.toLowerCase() ?? "";

          const descripcion = capacitacion.descripcion?.toLowerCase() ?? "";

          const id = String(capacitacion.id ?? "").toLowerCase();

          const estado = this.esActivo(capacitacion) ? "activo" : "inactivo";

          return (
            nombre.includes(term) ||
            tema.includes(term) ||
            descripcion.includes(term) ||
            id.includes(term) ||
            estado.includes(term)
          );
        });

    this.sortCurrentData();
  }

  abrirModalNuevo(content: TemplateRef<any>): void {
    this.newCapacitacionForm = {
      nombre: "",
      descripcion: "",
      tema: "",
      estado: 1,
    };

    this.createError = "";

    this.createModalRef = this.modalService.open(content, {
      centered: true,
      size: "xl",
      backdrop: "static",
    });
  }

  guardarNuevaCapacitacion(): void {
    this.createError = "";

    if (!this.newCapacitacionForm.nombre?.trim()) {
      this.mostrarAlerta(
        "Campo requerido",
        "Ingrese el nombre de la capacitación",
        "info",
      );

      return;
    }

    if (!this.newCapacitacionForm.tema?.trim()) {
      this.mostrarAlerta("Campo requerido", "Ingrese el tema", "info");
      return;
    }

    if (!this.newCapacitacionForm.descripcion?.trim()) {
      this.mostrarAlerta("Campo requerido", "Ingrese la descripción", "info");
      return;
    }

    const payload: CapacitacionDTO = {
      nombre: this.newCapacitacionForm.nombre.trim().toUpperCase(),

      descripcion: this.newCapacitacionForm.descripcion?.trim() ?? null,

      tema: this.newCapacitacionForm.tema?.trim() ?? null,

      estado: Number(this.newCapacitacionForm.estado ?? 1),
    };

    this.loading = true;

    this.capacitacionesService.createCapacitacion(payload).subscribe({
      next: () => {
        this.loading = false;

        this.createModalRef?.close();

        Swal.fire({
          icon: "success",
          title: "Capacitación creada",
          text: "La capacitación se creó correctamente.",
        });

        this.cargarCapacitaciones();
      },

      error: (error) => {
        this.loading = false;

        Swal.fire({
          icon: "error",
          title: "No se pudo guardar la capacitación",

          text:
            error?.error?.message ||
            "Revisa la información e inténtalo de nuevo.",
        });
      },
    });
  }

  abrirModalEditar(
    capacitacion: CapacitacionView,
    content: TemplateRef<any>,
  ): void {
    if (!capacitacion?.id) {
      return;
    }

    this.loading = true;

    this.capacitacionesService.getCapacitacionById(capacitacion.id).subscribe({
      next: (data) => {
        this.loading = false;

        this.editCapacitacionId = Number(data.id);

        this.editCapacitacionForm = {
          nombre: data.nombre ?? "",

          descripcion: data.descripcion ?? "",

          tema: data.tema ?? "",

          estado: Number(data.estado ?? 1),
        };

        this.editError = "";

        this.editModalRef = this.modalService.open(content, {
          centered: true,
          size: "xl",
          backdrop: "static",
        });
      },

      error: (error) => {
        this.loading = false;

        Swal.fire({
          icon: "error",
          title: "Error",
          text: error?.error?.message || "No se pudo cargar la capacitación",
        });
      },
    });
  }

  guardarEdicion(): void {
    this.editError = "";

    if (!this.editCapacitacionId) {
      this.mostrarAlerta(
        "Error",
        "No se encontró la capacitación a editar",
        "error",
      );

      return;
    }

    if (!this.editCapacitacionForm.nombre?.trim()) {
      this.mostrarAlerta(
        "Campo requerido",
        "Ingrese el nombre de la capacitación",
        "info",
      );

      return;
    }
    if (!this.editCapacitacionForm.tema?.trim()) {
      this.mostrarAlerta("Campo requerido", "Ingrese el tema", "info");
      return;
    }

    if (!this.editCapacitacionForm.descripcion?.trim()) {
      this.mostrarAlerta("Campo requerido", "Ingrese la descripción", "info");
      return;
    }


    const payload: CapacitacionDTO = {
      nombre: this.editCapacitacionForm.nombre.trim().toUpperCase(),

      descripcion: this.editCapacitacionForm.descripcion?.trim() ?? null,

      tema: this.editCapacitacionForm.tema?.trim() ?? null,

      estado: Number(this.editCapacitacionForm.estado ?? 1),
    };

    this.loading = true;

    this.capacitacionesService
      .updateCapacitacion(this.editCapacitacionId, payload)
      .subscribe({
        next: () => {
          this.loading = false;

          this.editModalRef?.close();

          Swal.fire({
            icon: "success",
            title: "Capacitación actualizada",
            text: "La capacitación se actualizó correctamente.",
          });

          this.cargarCapacitaciones();
        },

        error: (error) => {
          this.loading = false;

          Swal.fire({
            icon: "error",
            title: "No se pudo guardar la capacitación",

            text:
              error?.error?.message ||
              "Revisa la información e inténtalo de nuevo.",
          });
        },
      });
  }

  activarCapacitacion(id: number | string | undefined): void {
    if (id == null) {
      return;
    }

    this.capacitacionesService.activar(id).subscribe({
      next: () => {
        Swal.fire(
          "Activada",
          "La capacitación fue activada correctamente.",
          "success",
        );

        this.cargarCapacitaciones();
      },

      error: () => {
        Swal.fire("Error", "No se pudo activar la capacitación.", "error");
      },
    });
  }

  inactivarCapacitacion(id: number | string | undefined): void {
    if (id == null) {
      return;
    }

    Swal.fire({
      title: "¿Desea inactivar esta capacitación?",

      text: "El registro quedará disponible en inactivos.",

      icon: "warning",

      showCancelButton: true,

      confirmButtonText: "Sí, inactivar",

      cancelButtonText: "Cancelar",
    }).then((result: any) => {
      if (!result.isConfirmed) {
        return;
      }

      this.capacitacionesService.inactivar(id).subscribe({
        next: () => {
          Swal.fire(
            "Inactivada",
            "La capacitación fue inactivada correctamente.",
            "success",
          );

          this.cargarCapacitaciones();
        },

        error: () => {
          Swal.fire("Error", "No se pudo inactivar la capacitación.", "error");
        },
      });
    });
  }

  sortData(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    } else {
      this.sortColumn = column;
      this.sortDirection = "asc";
    }

    this.sortCurrentData();
  }

  private sortCurrentData(): void {
    if (!this.sortColumn) {
      return;
    }

    this.filteredTableItems.sort((a: any, b: any) => {
      const valueA = (a?.[this.sortColumn] ?? "").toString().toLowerCase();

      const valueB = (b?.[this.sortColumn] ?? "").toString().toLowerCase();

      if (valueA < valueB) {
        return this.sortDirection === "asc" ? -1 : 1;
      }

      if (valueA > valueB) {
        return this.sortDirection === "asc" ? 1 : -1;
      }

      return 0;
    });
  }

  exportToPDF(tableId: string, nameFile: string, titleFile: string): void {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string): void {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

  private mostrarAlerta(titulo: string, mensaje: string, icono: any) {
    Swal.fire({
      title: titulo,
      text: mensaje,
      icon: icono,
      confirmButtonColor: "#3085d6",
    });
  }
}
